import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as CreDtos from "../CRE.dtos";
import { peopleApi } from "../services/people";

import {
    PEOPLE_REQUEST,
    peopleRequestSuccess,
    peopleRequestFailure,
    peopleRequest,
    PEOPLE_UPSERT_REQUEST,
    peopleUpsertRequestFailure,
    peopleUpsertRequestSuccess,
    PEOPLE_UPSERT_REQUEST_SUCCESS,
    PEOPLE_UPSERT_REQUEST_FAILURE
} from "../actions/people.actions";

import {
    siteDataRequest
} from "../actions/sitedata.actions";

import {
    notificationSuccessShow,
    notificationErrorShow
} from "../actions/notification.actions";

export const peopleRequestEpic = action$ =>
    action$
        .ofType(PEOPLE_REQUEST)
        .mergeMap((action) =>
            peopleApi
                .get()
                .mergeMap(response => {
                    return concat$(Observable.of(peopleRequestSuccess(response.people, response.categories)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(peopleRequestFailure(error.responseStatus.message))
                )
        );

export const peopleUpsertRequestEpic = action$ =>
    action$
        .ofType(PEOPLE_UPSERT_REQUEST)
        .mergeMap((action) =>
            peopleApi
                .upsert(action.people)
                .mergeMap(response => {
                    return concat$(Observable.of(peopleUpsertRequestSuccess(response.people)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(peopleUpsertRequestFailure(error.responseStatus.message))
                )
        );

export const peopleUpsertRequestSuccessEpic = (action$, state$) =>
    action$
        .ofType(PEOPLE_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => peopleRequest());

export const peopleUpsertRequestSuccessNotificationEpic = (action$, state$) =>
    action$
        .ofType(PEOPLE_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => notificationSuccessShow(action.people.title + " saved"));

export const peopleUpsertRequestSuccessSiteDataEpic = (action$, state$) =>
        action$
            .ofType(PEOPLE_UPSERT_REQUEST_SUCCESS)
            .map((action: any) => siteDataRequest());

export const peopleUpsertRequestErrorNotificationEpic = (action$, state$) =>
    action$
        .ofType(PEOPLE_UPSERT_REQUEST_FAILURE)
        .map((action: any) => notificationErrorShow("Save failed: " + action.error));


// WEBPACK FOOTER //
// ./src/epics/people.epic.ts